<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-card>
              <v-card-text>
                <div>
                  By selecting an option below, you decide who the kiosk scan
                  applies to:
                </div>
                <v-radio-group v-model="configuration" row>
                  <v-radio label="Employee" value="EMPLOYEE"></v-radio>
                  <v-radio label="Visitor" value="VISITOR"></v-radio>
                  <v-radio label="Employee and Visitor" value="BOTH"></v-radio>
                </v-radio-group>
                <div v-if="configuration == 'EMPLOYEE'">
                  Employees: Scan applies only to employees and consumes 1
                  credit.
                </div>
                <div v-if="configuration == 'VISITOR'">
                  Visitors: Scan applies only to visitors and consumes 2
                  credits.
                </div>
                <div v-if="configuration == 'BOTH'">
                  Employee and Visitor: Scan applies to both employees and
                  visitors and consumes 3 credits.
                </div>
              </v-card-text>
              <v-card-actions class="">
                <v-btn
                  color="primary"
                  class="white--text"
                  :loading="loading"
                  @click="update_mutation()"
                  small
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <SnackBar :SnackBarComponent="SnackBarComponent" />
  </div>
</template>

<script>
import { GetCurrentUserDetailsnew } from "@/mixins/getCurrentUserDetails.js";
import SnackBar from "@/components/SnackBar.vue";
import { API, graphqlOperation } from "aws-amplify";
import { onboard_org_settings } from "@/graphql/mutations.js";
export default {
  mixins: [GetCurrentUserDetailsnew],
  components: {
    SnackBar,
  },
  data() {
    return {
      configuration: "EMPLOYEE",
      loading: false,
      SnackBarComponent: {},
    };
  },
  async mounted() {
    await this.GetCurrentUserDetailsnew();
    this.configuration =
      this.$store.getters.get_org_details[0].kiosk_type == undefined
        ? "EMPLOYEE"
        : this.$store.getters.get_org_details[0].kiosk_type;
    console.log(this.$store.getters.get_org_details[0]);
  },
  methods: {
    async update_mutation() {
      this.loading = true;
      try {
        let result = await API.graphql(
          graphqlOperation(onboard_org_settings, {
            input: {
              organisation_id:
                this.$store.getters.get_org_details[0].organisation_id,
              kiosk_type: this.configuration,
            },
          })
        );

        var response = result.data.onboard_org_settings;
        this.loading = false;
        if (response.Status == "SUCCESS") {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            SnackbarText: response.Message,
            timeout: 5000,
            Top: true,
          };
          await this.GetCurrentUserDetailsnew();
          this.configuration =
            this.$store.getters.get_org_details[0].kiosk_type;
          this.loading = false;
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            SnackbarText: response.Message,
            timeout: 5000,
            Top: true,
          };

          this.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: error.errors[0].message,
          timeout: 5000,
          Top: true,
        };

        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>